import { dummyDataService } from "./services";
import { ItemPage, LibraryCard } from "./components";
import { faCodePullRequest } from "@fortawesome/free-solid-svg-icons";
import { ModuleTypeEnum } from "../../enums";
import { IModuleConfig } from "../../interfaces";
import {
  BackButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
} from "./components/toolbar-items";

const config: IModuleConfig = {
  id: "requests",
  name: "Access Requests",
  icon: faCodePullRequest,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: LibraryCard,
    itemPage: ItemPage,
  },
  services: {
    getByPage: dummyDataService.getByPage,
    getSingle: dummyDataService.getSingle,
    search: dummyDataService.search,
    create: dummyDataService.create,
    update: dummyDataService.update,
    delete: dummyDataService.delete,
  },
  utilities: {
    extractKey: (d: any) => d.id,
    extractItemPath: (d: any) => d.id,
    extractItemBreadcrumb: (d: any) => `${d.buyerName}`,
  },
  toolbarItems: {
    library: [],
    view: [
      BackButton,
      "|",
      EditButton,
      DeleteButton,
      // "|",
      // Report1Button,
      // Report2Button,
    ],
    edit: [SaveButton, CancelButton],
    create: [],
  },
};

export default config;
